module.exports = __webpack_public_path__ + "img/196.48d61c09.jpg";